import React from 'react'
import { Box, Image, Heading, useColorModeValue } from '@chakra-ui/react'

export default function ChosenUoaImage({ src, title, maxW }) {
	const border = useColorModeValue('gray.200', 'whiteAlpha.300')
	const bg = useColorModeValue('white', 'bgg.800')
	const containerMaxW = maxW != null ? maxW : 'sm'

	return (
		<Box
			maxW={containerMaxW}
			w="full"
			overflow="hidden"
			rounded="2xl"
			borderWidth="1px"
			borderColor={border}
			bg={bg}
			boxShadow="md"
		>
			<Box w="full" minH="200px" bg="gray.100" lineHeight={0} textAlign="center">
				<Image
					src={src}
					alt=""
					w="full"
					maxW="100%"
					h="auto"
					maxH="min(70vh, 640px)"
					objectFit="contain"
					display="inline-block"
					verticalAlign="top"
					bg="gray.100"
				/>
			</Box>
			<Box p={6}>
				<Heading size="md" color="gray.800" lineHeight="short" _dark={{ color: 'gray.100' }}>
					{title}
				</Heading>
			</Box>
		</Box>
	)
}
